import { useContext } from 'react';
import { ProjectContext } from '../types/Project';
import ProjectsContext from '../contexts/project/ProjectContext';

const useProject = (): ProjectContext => useContext(ProjectsContext);

export default useProject;
